import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      'Welcome to React': 'Welcome to React and react-i18next'
    }
  },
  fr: {
    translation: {
      'Welcome to React': 'Bienvenue à React et react-i18next'
    }
  },
  zhCN: {
    translation: {
      'Welcome to React': '欢迎',
      'browse describe': '100+个单独的组件，35+个屏幕'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'zhCN',
    fallbackLng: 'zhCN',
    interpolation: {
      escapeValue: false
    }
  });
